var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C25.3137 2.57702e-07 28 2.68629 28 6V22C28 25.3137 25.3137 28 22 28H6C2.68629 28 3.22139e-08 25.3137 0 22V6C2.57711e-07 2.68629 2.68629 3.22128e-08 6 0H22ZM14.4307 4.66699V17.9453C14.4307 18.52 13.5772 19.5249 13.0752 19.7979C10.5183 21.1872 7.86891 18.167 9.58887 15.8213C9.82916 15.4941 10.7141 14.7804 11.0977 14.7803H12.4141C12.4388 14.7803 12.478 14.8845 12.5381 14.8623V11.5732C7.6893 10.9525 4.15703 16.1552 6.66016 20.4463C9.0459 24.5359 15.1785 24.2138 17.1348 19.9072C17.2755 19.5973 17.6405 18.5616 17.6406 18.2744V10.915C18.9788 11.7874 20.5375 12.4023 22.167 12.3135V9.22949C21.8378 9.04943 21.3576 9.07168 20.9453 8.96973C19.023 8.49447 17.6893 6.61301 17.6406 4.66699H14.4307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.641 4.6665C17.6895 6.61268 19.0236 8.49472 20.946 8.96996C21.3583 9.07191 21.8381 9.04971 22.1673 9.22978V12.313C20.5378 12.4018 18.9791 11.7876 17.641 10.9153V18.2741C17.641 18.561 17.2764 19.597 17.1357 19.907C15.1795 24.2137 9.04678 24.536 6.66101 20.4464C4.15756 16.1552 7.68972 10.9523 12.5386 11.573V14.8619C12.4785 14.8841 12.4399 14.7797 12.4152 14.7797H11.0984C10.7149 14.7797 9.83024 15.4942 9.58993 15.8214C7.86994 18.1672 10.5191 21.1872 13.076 19.7976C13.578 19.5247 14.4314 18.5199 14.4314 17.9452V4.6665H17.641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokImage);
export default __webpack_public_path__ + "static/media/tiktok-image.cd12d07816782c0bafff4ac1b232d254.svg";
export { ForwardRef as ReactComponent };